
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRouteExportProposal as ObiRouteExportProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-route-export-proposal.js';
 
 
 

 
 export const ObiRouteExportProposal = createComponent({
   react: React,
   tagName: 'obi-route-export-proposal',
   elementClass: ObiRouteExportProposalElement,
   events: {
     
   }
  });
 
 